module.exports = __webpack_public_path__ + "8317bf1fc9517d15d49c615b596c464a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/evaluation_report/assets/grammarBg.jpg
// module id = 788
// module chunks = 0